import {Injectable} from '@angular/core';
import {Adapter} from '../interfaces/adapter';
import {ThirdPartyConsentStatusEnum} from '@secca/shared/models/enums';
import moment from 'moment';

export class ThirdPartyConsent {
  id: number;
  seccaCaseId: number;
  stakeholderName: string;
  consentType: ThirdPartyConsentStatusEnum;
  hasLegalGuardian: boolean;
  caseStakeholder: number;
  consentText: string;
  stakeholderRemarks: string

  public constructor(init?: Partial<ThirdPartyConsent>) {
    Object.assign(this, init);
  }
}

@Injectable({
  providedIn: 'root'
})
export class ThirdPartyConsentAdapter implements Adapter<ThirdPartyConsent> {

  adapt(item: any): ThirdPartyConsent {
    if (item == null) {
      return new ThirdPartyConsent();
    }

    return new ThirdPartyConsent({
      id: item.id,
      seccaCaseId: item.seccaCaseId,
      stakeholderName: item.stakeholderName,
      consentType: item.consentType,
      hasLegalGuardian: item.hasLegalGuardian,
      caseStakeholder: item.caseStakeholder,
      stakeholderRemarks: item.stakeholderRemarks
    });
  }
}
